export default __webpack_public_path__ + "static/media/logo-square.4066095d.svg";